import { WithdrawTable } from "widgets/withdraw-table";

export function WithdrawPage() {
  return <WithdrawTable></WithdrawTable>;
}
